import { render, staticRenderFns } from "./SubBundle.vue?vue&type=template&id=5304fd7a"
import script from "./SubBundle.vue?vue&type=script&lang=js"
export * from "./SubBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports